import { API } from 'aws-amplify';
import { find } from 'lodash';

const API_NAME = 'recruitment';
const API_VERSION = '/v1';

/**
 * Our modulestate is persisted in localstorage, so we use
 * lastUpdated to refresh the data when needed.
 */
const modulestate = () => ({
  lastUpdated: null,
  // --
  locations: [],
  employmentTypes: [],
  payTypes: [],
  termTypes: [],
  qualifications: [],
  qualificationLevels: [],
});
const getters = {
  locations: (state) => state.locations,
  employmentTypes: (state) => state.employmentTypes,
  payTypes: (state) => state.payTypes,
  termTypes: (state) => state.termTypes,
  qualifications: (state) => state.qualifications,
  qualificationLevels: (state) => state.qualificationLevels,
};
const mutations = {
  locations(state, val) { state.locations = val; },
  employmentTypes(state, val) { state.employmentTypes = val; },
  payTypes(state, val) { state.payTypes = val; },
  termTypes(state, val) { state.termTypes = val; },
  qualifications(state, val) { state.qualifications = val; },
  qualificationLevels(state, val) { state.qualificationLevels = val; },
  lastUpdated(state, val) { state.lastUpdated = val; },
};
const actions = {
  async fetchSettings(context) {
    // check to see if we can return cached data
    if (context.state.lastUpdated != null) {
      const today = new Date();
      if (
        `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`
          === context.state.lastUpdated
      ) {
        return context.state;
      }
    }
    const promises = [];
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/locations`));
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/employmentTypes`));
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/payTypes`));
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/termTypes`));
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/qualifications`));
    promises.push(API.get(API_NAME, `${API_VERSION}/settings/qualificationLevels`));
    const result = await Promise.all(promises);
    context.commit('locations', result.shift().value);
    context.commit('employmentTypes', result.shift().value);
    context.commit('payTypes', result.shift().value);
    context.commit('termTypes', result.shift().value);
    context.commit('qualifications', result.shift().value);
    context.commit('qualificationLevels', result.shift().value);
    const today = new Date();
    context.commit('lastUpdated', `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`);
    return context.state;
  },
};

export const resolveSettingProperty = (settingsObject, key, property = 'name') => {
  const match = find(settingsObject, ['value', key]);
  if (match) {
    return match[property];
  }
  return key;
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
